var bec_app = {};

// Define constants
bec_app.MOBILE_MAX_WIDTH = 768;
bec_app.TABLET_MAX_WIDTH = 992;
bec_app.DEFAULT_DURATION = 300;
bec_app.HEADER_HEIGHT = 75;


bec_app.toggleMenu = function(menuElt, bodyClass ,duration) {
  if (!duration) duration = bec_app.DEFAULT_DURATION;

  // Prevent the scroll bar over the menu
  jQuery('html').toggleClass(bodyClass);
  jQuery('body').toggleClass(bodyClass);

  menuElt.toggleClass('expanded');

};

bec_app.toggleHeaderStyle = function() {
  var opacity = jQuery(window).scrollTop() / (bec_app.HEADER_HEIGHT * 4);

  if (opacity > 0.8) opacity = 0.8;
  jQuery('#navbar-header').css('background-color', 'rgba(39,37,87,' + opacity + ')');

  if (jQuery(window).scrollTop() > (bec_app.HEADER_HEIGHT *2)) {
    jQuery('#navbar-header').addClass('header-small').removeClass('header-large');
  } else {
    jQuery('#navbar-header').removeClass('header-small').addClass('header-large');
  }
};

bec_app.scrollTo = function(selector) {
  jQuery(selector).animatescroll( {
    padding: bec_app.HEADER_HEIGHT,
    scrollSpeed: 600,
    easing: 'easeInOutQuad'
  });
};

/* Set the flexible background image depending on screen width (home refs, hero ref detail)*/
bec_app.setFlexibleBgImages = function() {
  jQuery('.flexible-bg-image').each(function(){
    var imageUrl;
    if (jQuery(window).width() >= bec_app.TABLET_MAX_WIDTH) {
      imageUrl = 'url("' + jQuery(this).attr('data-image-md') + '")';
    } else {
      imageUrl = 'url("' + jQuery(this).attr('data-image-xs') + '")';
    }

    if (jQuery(this).css('background-image') != imageUrl) {
      jQuery(this).css('background-image', imageUrl);
    }

  });
};

jQuery(document).ready(function($) {
  // Init interface
  bec_app.toggleHeaderStyle();
  bec_app.setFlexibleBgImages();


  $('#btn-menu-open, #btn-menu-close').click(function() {
    bec_app.toggleMenu($('#main-menu'), 'menu-open');
  });

  $('.home-reference').hover(function() {
    $(this).children('.reference-description').toggleClass('animated fadeIn');
  });

  // Removes some anchor links managed by js click/animatescroll.
  // And manage scroll buttons
  $('.scroll-link').removeAttr('href');

  $('.scroll-to-top').click(function(){
    bec_app.scrollTo('#page-top');
  });

  $('.job-button-apply').click(function(){
    $('#job-application-title').text($(this).attr('data-label'));
    $('#job-application-job').val($(this).attr('data-label'));

    bec_app.scrollTo('#job-application');
  });

  $('#timeline li').hover(
    function() {
      // Force the mouse leave on the first element if active
      $('#timeline li:first').trigger('mouseleave');
      $('#timeline-step-label').html($(this).children('span').html());
      $(this).addClass('hover-active');
    },
    function() {
      $('#timeline-step-label').html('&nbsp;');
      $(this).removeClass('hover-active');
    }
  );

  /* https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/ */
  $('.input-file').on('change', function(e) {
    var fileName = '';
    var labelElt = $(this).parents('.input-file-wrapper').children('.label-file');
    var labelVal = labelElt.html();

    if (e.target.value) {
      fileName = e.target.value.split( '\\' ).pop();
    }

    if (fileName) {
      labelElt.html(fileName);
    } else {
      labelElt.html(labelVal);
    }
  });

  // Filter references
  $('.references-filter-button').click(function(e) {
    e.preventDefault();

    var currentButton = $(this);
    var domainId = currentButton.attr('data-domain-id');

    jQuery.post(
      bec_data.ajax_url,
      {
        'action': 'filter_references',
        'domainId': domainId
      },
      function(response){
        $('#references-container').empty();
        $('#references-container').append(response);

        $('.references-filter-button').removeClass('active');
        $('#references-filter-reset').removeClass('active');
        currentButton.addClass('active');
      }
    );
  });

  $('#references-filter-reset').click(function(e) {
    e.preventDefault();

    jQuery.post(
      bec_data.ajax_url,
      {
        'action': 'filter_references'
      },
      function(response){
        $('#references-container').empty();
        $('#references-container').append(response);

        $('.references-filter-button').removeClass('active');
        $('#references-filter-reset').addClass('active');
      }
    );

    return false;
  });

  // Simulate hover on touch screens
  $('.hover-element').on('mouseenter mouseleave touchstart', function (e) {
    if(e.type == 'touchstart') {
      $(this).off('mouseenter mouseleave');
    }

    $(this).toggleClass('hover-active');
  });


  // Manage CF7 email sent to reset button labels
  $('.wpcf7').on('wpcf7mailsent', function(event) {
    $('.label-file').html("Sélectionner votre fichier");
  });

  // Simulate mouse enter on timeline first elt
  $('#timeline li:first').trigger('mouseenter');

  $('#new-collaborator-img').hover(
    function() {
      $(this).attr('src', $(this).attr('data-image-hover'));
    },
    function() {
      $(this).attr('src', $(this).attr('data-image'));
    }
  );

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add("active");
    });
  });
  document.querySelectorAll(".animate").forEach(el => observer.observe(el));
});

jQuery(window).scroll(function() {
  bec_app.toggleHeaderStyle();
});

jQuery(window).resize(function() {
  bec_app.toggleHeaderStyle();
  bec_app.setFlexibleBgImages();
});
